import _ from "lodash";
import { appConfig } from "config/initializers/config.app";

export const FETCH_ALL_USERS = "FETCH_ALL_USERS";
export const UPDATE_USER = "UPDATE_USER";

/*
 * Action Creators
 */

function _fetchUsers(status, err, data) {
    return {
        type: FETCH_ALL_USERS,
        status,
        err,
        data,
    };
}
function _updateUser(status, err, data) {
    return {
        type: UPDATE_USER,
        status,
        err,
        data,
    };
}
function fetchCreators() {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            "/api/v2/analytics/reports/amplayfy/creators/fetch",
            {
                method: "GET",
            }
        )
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(data);
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function fetchViewers() {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            "/api/v2/analytics/reports/amplayfy/viewers/fetch",
            {
                method: "GET",
            }
        )
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(data);
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function fetchCreatorViewers() {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            "/api/v2/analytics/reports/amplayfy/viewers/creator",
            {
                method: "GET",
            }
        )
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(data);
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function fetchUsers() {
    return (dispatch, getState, Request) => {
        return Request.fetch(appConfig.endpoints.getUserListPath, {
            method: "GET",
        })
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(
                        dispatch(_fetchUsers("success", null, data))
                    );
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function fetchUserSearch(query) {
    return (dispatch, getState, Request) => {
        return Request.fetch(appConfig.endpoints.getUserSearchPath, {
            method: "POST",
            body: JSON.stringify({ query: query }),
        })
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(data);
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function fetchUserQuery(query) {
    return (dispatch, getState, Request) => {
        return Request.fetch(appConfig.endpoints.getUserQueryPath, {
            method: "POST",
            body: JSON.stringify(query),
        })
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(data);
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function fetchDeactivatedUsers() {
    return (dispatch, getState, Request) => {
        return Request.fetch(appConfig.endpoints.getDeactivatedUsersPath, {
            method: "GET",
        })
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(data);
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function fetchUserDetails(userId) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.getUserDetailsPath
                .replace(":id", userId)
                .replace("show", "showAdmin"),
            {
                method: "GET",
            }
        )
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(data);
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function fetchUserAncestors(userId) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.getUserAncestorsPath.replace(":id", userId),
            {
                method: "GET",
            }
        )
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(data);
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function fetchUserDescendants(userId) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.getUserDescendantsPath.replace(":id", userId),
            {
                method: "GET",
            }
        )
            .then((response) => {
                return response.json().then((data) => {
                    return Promise.resolve(data);
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function addUser(username, name, email, password, manager, details, enroll) {
    return (dispatch, getState, Request) => {
        let modEmail = _.chain(email).trim().toLower().value();
        let nameSplit = name.split(" ");
        return Request.fetch(
            enroll
                ? appConfig.endpoints.createAndEnrollUserPath
                : appConfig.endpoints.createUserPath,
            {
                method: "POST",
                body: JSON.stringify({
                    email: modEmail,
                    password: password,
                    first_name: _.startCase(_.toLower(nameSplit[0])),
                    last_name:
                        nameSplit[1] === undefined
                            ? " "
                            : _.startCase(_.toLower(nameSplit[1])),
                    username: username,
                    manager: manager,
                    details: details,
                }),
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((userData) => {
                return Promise.resolve(userData);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function updateUserDetails(id, detailsObj) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.updateUserDetailsPath.replace(":id", id),
            {
                method: "POST",
                body: JSON.stringify({ details: detailsObj }),
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((userData) => {
                return Promise.resolve("Modified");
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function updateProfile(id, profileObj) {
    return (dispatch, getState, Request) => {
        const profileUpdate = {
            company: profileObj.company,
            address: profileObj.address,
            webpage: profileObj.webpage,
            bio: profileObj.bio,
            logo: profileObj.logo,
        };
        const mainUpdate = {
            first_name: profileObj.first_name,
            last_name: profileObj.last_name,
            image: profileObj.image,
            email: profileObj.email,
        };

        return Request.fetch(
            appConfig.endpoints.updateUserProfilePath.replace(":id", id),
            {
                method: "POST",
                body: JSON.stringify({ profile: profileUpdate }),
            }
        )
            .then((response) => {
                return response.json();
            })
            .then(() => {
                return Request.fetch("/api/v2/users/self/update", {
                    method: "POST",
                    body: JSON.stringify(mainUpdate),
                })
                    .then((response) => {
                        return response.json();
                    })
                    .then((userData) => {
                        return dispatch(_updateUser("success", null, userData));
                    });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function updateUserManager(id, manager) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.updateUserManagerPath.replace(":id", id),
            {
                method: "POST",
                body: JSON.stringify({ manager: manager }),
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((userData) => {
                return Promise.resolve("Modified");
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function updateLicense(id, licenseObj) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.updateUserLicensePath.replace(":id", id),
            {
                method: "POST",
                body: JSON.stringify(licenseObj),
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((userData) => {
                return Promise.resolve("Modified");
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function activateUser(id) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.activateUserPath.replace(":id", id),
            {
                method: "POST",
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((userData) => {
                return Promise.resolve("Modified");
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function deactivateUser(id) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.deactivateUserPath.replace(":id", id),
            {
                method: "POST",
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((userData) => {
                return Promise.resolve("Modified");
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}
function deleteUser(id) {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.deleteUserPath.replace(":id", id),
            {
                method: "POST",
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((userData) => {
                return Promise.resolve("Modified");
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}

const fetchTags = () => {
    return (dispatch, getState, Request) => {
        let tagsPath = appConfig.endpoints.tagsPath;
        return Request.fetch(tagsPath)
            .then((response) => {
                return response.json().then((data) => {
                    return data;
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};
const createTags = (tags) => {
    return (dispatch, getState, Request) => {
        let createTagsPath = appConfig.endpoints.createTagsPath;
        return Request.fetch(createTagsPath, {
            method: "POST",
            body: JSON.stringify({ tags: tags }),
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
            });
    };
};
const editTag = (id, tag) => {
    return (dispatch, getState, Request) => {
        let editTagPath = appConfig.endpoints.editTagPath.replace(":id", id);
        return Request.fetch(editTagPath, {
            method: "POST",
            body: JSON.stringify(tag),
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
            });
    };
};
const deleteTag = (tagId) => {
    return (dispatch, getState, Request) => {
        let deleteTagPath = appConfig.endpoints.deleteTagPath.replace(
            ":id",
            tagId
        );
        return Request.fetch(deleteTagPath, {
            method: "POST",
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

const fetchAdverts = () => {
    return (dispatch, getState, Request) => {
        let getAdvertsPath = appConfig.endpoints.getAdvertsPath;
        return Request.fetch(getAdvertsPath)
            .then((response) => {
                return response.json().then((data) => {
                    return data;
                });
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};
const createAdvert = (advert) => {
    return (dispatch, getState, Request) => {
        let createAdvertPath = appConfig.endpoints.createAdvertPath;
        return Request.fetch(createAdvertPath, {
            method: "POST",
            body: JSON.stringify(advert),
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
            });
    };
};
const editAdvert = (id, advert) => {
    return (dispatch, getState, Request) => {
        let editAdvertPath = appConfig.endpoints.editAdvertPath.replace(
            ":id",
            id
        );
        return Request.fetch(editAdvertPath, {
            method: "POST",
            body: JSON.stringify(advert),
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
            });
    };
};
const deleteAdvert = (id) => {
    return (dispatch, getState, Request) => {
        let deleteAdvertPath = appConfig.endpoints.deleteAdvertPath.replace(
            ":id",
            id
        );
        return Request.fetch(deleteAdvertPath, {
            method: "POST",
        })
            .then((resp) => {
                return resp.json();
            })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
            });
    };
};

const sendUpgradeRequest = (id, requestdetails) => {
    return (dispatch, getState, Request) => {
        return Request.fetch(
            appConfig.endpoints.sendUpgradeRequest.replace(":id", id),
            {
                method: "POST",
                body: JSON.stringify(requestdetails),
            }
        )
            .then((response) => {
                return response.json();
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
}

class AdminPanelAction {
    static fetchUsers = fetchUsers;
    static fetchCreators = fetchCreators;
    static fetchViewers = fetchViewers;
    static fetchCreatorViewers = fetchCreatorViewers;
    static fetchUserQuery = fetchUserQuery;
    static fetchUserSearch = fetchUserSearch;
    static fetchDeactivatedUsers = fetchDeactivatedUsers;
    static fetchUserDetails = fetchUserDetails;
    static fetchUserAncestors = fetchUserAncestors;
    static fetchUserDescendants = fetchUserDescendants;
    static addUser = addUser;
    static updateUserDetails = updateUserDetails;
    static updateUserManager = updateUserManager;
    static updateLicense = updateLicense;
    static updateProfile = updateProfile;
    static activateUser = activateUser;
    static deactivateUser = deactivateUser;
    static deleteUser = deleteUser;
    static fetchTags = fetchTags;
    static createTags = createTags;
    static editTag = editTag;
    static deleteTag = deleteTag;
    static fetchAdverts = fetchAdverts;
    static createAdvert = createAdvert;
    static editAdvert = editAdvert;
    static deleteAdvert = deleteAdvert;
    static sendUpgradeRequest = sendUpgradeRequest;
}

export { AdminPanelAction };
